import { render, staticRenderFns } from "./FittingNotifications.vue?vue&type=template&id=2ee60eaa&"
import script from "./FittingNotifications.vue?vue&type=script&lang=js&"
export * from "./FittingNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports